import { useState } from "react";
import api from "@/lib/api";
import { useToast } from "@/hooks/use-toast";

/**
 * Encapsulates all form state + submit logic for the status-change dialog,
 * keeping the dialog component itself focused on rendering.
 */
export function useStatusChangeForm(caseId, onUpdated, onOpenChange) {
  const [target, setTarget] = useState(null);
  const [note, setNote] = useState("");
  const [photos, setPhotos] = useState([]);
  const [date, setDate] = useState(() => new Date().toISOString().slice(0, 10));
  const [confirmed, setConfirmed] = useState(false);
  const [saving, setSaving] = useState(false);
  const { toast } = useToast();

  const reset = () => {
    setTarget(null);
    setNote("");
    setPhotos([]);
    setDate(new Date().toISOString().slice(0, 10));
    setConfirmed(false);
  };

  const handleOpenChange = (v) => {
    onOpenChange(v);
    if (!v) reset();
  };

  const submit = async (status) => {
    setSaving(true);
    try {
      await api.post(`/cases/${caseId}/status`, { status, note, photo: photos[0] || null, date });
      toast({ title: `Status updated to ${status}` });
      onUpdated();
      onOpenChange(false);
      reset();
    } catch {
      toast({ variant: "destructive", title: "Could not update status" });
    } finally {
      setSaving(false);
    }
  };

  return {
    target, setTarget,
    note, setNote,
    photos, setPhotos,
    date, setDate,
    confirmed, setConfirmed,
    saving,
    handleOpenChange,
    submit,
  };
}
